export const environment = {
  production: true,
  // Configurações Aplicação:
  serverUrl: 'https://backend.smg-teste.rs.gov.br',
  clientUrl: 'https://smg-teste.rs.gov.br/',
  apiUrl: 'https://backend.smg-teste.rs.gov.br/rest/api',
};
